import debounce from 'debounce';
import select from 'dom-select';
import L from 'leaflet';
import { fullscreen} from 'leaflet.fullscreen'; // eslint-disable-line no-unused-vars
import { GestureHandling } from "leaflet-gesture-handling";

import imgPinIcon from '@images/leaflet/marker-icon.png';
import imgPinShadow from '@images/leaflet/marker-shadow.png';

import Mark from 'mark.js';

export const Openstreetmap = (el) => {
  const ui = {
    el,
    body: select('body', document),
    toggle: select('#js-map-toggle', el),
    mapContainer: select('.openstreetmap__map', el),
    allLinks: select.all('.openstreetmap__link', el),
    allCheckboxes: select.all('.input-group .input', el),
    context: select('.openstreetmap__links', el),
    textFilter: select('.text-filter', el),
    formReset: select('.form [type="reset"]', el),
    areaFilter: select('#filter-area', el),
    serviceFilter: select('#filter-service', el),
    centerFilter: select('#filter-center', el),
  };

  // OSM Map
  // jawg access
  const accessToken = '38K30LTF6vlYM1Tx8OFce5wkA2A86kQ8SIsg2PSlV3FmNklNYAWP7bz4d0PSiJRn';
  const latitude = ui.mapContainer.getAttribute('data-latitude');
  const longitude = ui.mapContainer.getAttribute('data-longitude');
  const zoom = ui.mapContainer.getAttribute('data-zoom');
  const minZoom = ui.mapContainer.getAttribute('data-min-zoom');
  
  L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

  const map = L.map(ui.mapContainer, {
    attributionControl: false,
    center: [latitude, longitude],
    gestureHandling: true,
    minZoom: minZoom,
    zoom: zoom,
    zoomSnap: .25,
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: 'topleft'
    }
  });

  const iconStyles = L.icon({
    iconUrl: imgPinIcon,
    shadowUrl: imgPinShadow,
    iconAnchor: [16, 51],
    popupAnchor: [-3, -76],
    shadowSize: [68, 95],
    shadowAnchor: [24, 100],
  });

  let markerGroup = L.layerGroup().addTo(map);
  const threshold = 834;

  // input filters
  let filtersType = [];
  let filtersArea = [];
  let filtersService = [];
  let filtersCenter = [];

  const setMapTiles = () => {
    // Create a Tile Layer for the background
    let tiles = new L.tileLayer('https://tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token=' + accessToken, { /* optional options */ });
    tiles.addTo(map);
  }

  const clearMapMarkers = () => {
    markerGroup.clearLayers();
  }

  const setMapMarkers = () => {
    filterItems();
    clearMapMarkers();

    ui.allLinks.forEach(link => {
      let popupContent;

      if (link.classList.contains('include')) {
        const latitude = link.getAttribute('data-latitude');
        const longitude = link.getAttribute('data-longitude');
        const title = link.getAttribute('data-title');
        const popupEl = select('.js-popup-content', link);
        popupContent = popupEl && popupEl.innerHTML ? popupEl.innerHTML : 'No data';

        const marker = L.marker(
          [latitude, longitude],
          { 
            icon: iconStyles,
            draggable: false,
            title: title,
          }
        );

        marker.addTo(markerGroup).bindPopup(popupContent);
      }
    });
    //  debug();
  }

  // input filtering 
  const filterItems = () => {
    ui.allLinks.forEach(link => {
      link.classList.remove('include');
    });

    ui.allLinks.forEach(link => {
      let passesType = true;
      let passesArea = true;
      let passesService = true;
      let passesCenter = true;

      if (filtersType.length) {
        const dataTypes = link.getAttribute('data-location-type').split(',').map(s => s.trim());
        passesType = filtersType.some(type => dataTypes.includes(type));
      }
      if (filtersArea.length) {
        passesArea = filtersArea.includes(link.getAttribute('data-area'));
      }
      if (filtersService.length) {
        const dataServices = link.getAttribute('data-service').split(',').map(s => s.trim());
        passesService = filtersService.some(service => dataServices.includes(service));
      }
      if (filtersCenter.length) {
        passesCenter = filtersCenter.includes(link.getAttribute('data-center'));
      }

      if (passesType && passesArea && passesService && passesCenter) {
        link.classList.add('include');
      }
    });

    // integrate our filtering with MarkJS
    if (el.getAttribute('data-filtered-by-text')) {
      const allNonMarkedLinks = select.all('.openstreetmap__link:not(:has(mark))', el);
      allNonMarkedLinks.forEach(link => {
        link.classList.remove('include');
      });
    }

    el.classList.toggle('no-results', select.all('.include', el).length === 0);
  }

  // text filtering via MarkJS
  if (ui.context) {
    var instance = new Mark(ui.context);
    var options = {
      'exclude': ['.heading', '.openstreetmap__link-cta a'],
      'ignorePunctuation': [
        "`",
        "'",
        "ʻ", // respect the okina
        "’",
      ],
      'debug': false,
      'separateWordSearch': true,
      'done': function() {
        setMapMarkers();
      }
    }
  }

  const clearMarks = () => {
    ui.context.removeAttribute('data-filtered-by-text');
    instance.unmark();
  };

  const addMarks = (term) => {
    if (term) {
      instance.unmark();
      instance.mark(term, options);
      ui.el.setAttribute('data-filtered-by-text', 'true');
    } else {
      ui.el.removeAttribute('data-filtered-by-text');
      clearMarks();
    }
    setMapMarkers();
  }

  const debouncedAddMarks = debounce(addMarks, 200);

  const toggleView = () => {
    ui.el.classList.toggle('list-view');
  }

  const reset = () => {
    ui.el.removeAttribute('data-area');
    ui.el.removeAttribute('data-service');
    ui.el.removeAttribute('data-center');
    ui.el.removeAttribute('data-filtered-by-type');
    ui.el.removeAttribute('data-filtered-by-text');
    ui.el.classList.remove('hospital', 'urgent-care', 'primary-care', 'emergency-room', 'pharmacy');
    filtersType = [];
    filtersArea = [];
    filtersService = [];
    filtersCenter = [];
    clearMarks();
  }

  const getCheckboxValues = () => {
    // clear the array
    filtersType = [];
    // rebuild it
    filtersType = ui.allCheckboxes
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);
  }

  const handleResize = () => {
    switchToListView();
    map.invalidateSize();
  }

  const switchToListView = () => {
    if (ui.body.offsetWidth < threshold) {
      ui.el.classList.add('list-view');
      if (ui.toggle) {
        ui.toggle.checked = false;
      }
    } else {
      ui.el.classList.remove('list-view');
      if (ui.toggle) {
        ui.toggle.checked = true;
      }
    }
  }

  const addEvents = () => {
    if (ui.toggle) {
      ui.toggle.addEventListener('change', () => {
        toggleView();
      });
    }

    if (ui.formReset) {
      ui.formReset.addEventListener('click', () => {
        reset();
        setMapMarkers();
      });
    }

    if (ui.textFilter) {
      ui.textFilter.addEventListener('keyup', () => {
        debouncedAddMarks(ui.textFilter.value);
      });
    }

    if (ui.areaFilter) {
      ui.areaFilter.addEventListener('change', () => {
        filtersArea = ui.areaFilter.value ? [ui.areaFilter.value] : [];
        setMapMarkers();
      });
    }

    if (ui.centerFilter) {
      ui.centerFilter.addEventListener('change', () => {
        filtersCenter = ui.centerFilter.value ? [ui.centerFilter.value] : [];
        setMapMarkers();
      });
    }

    if (ui.serviceFilter) {
      ui.serviceFilter.addEventListener('change', () => {
        filtersService = ui.serviceFilter.value ? [ui.serviceFilter.value] : [];
        setMapMarkers();
      });
    }

    ui.allCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          el.classList.add(checkbox.value);
        } else {
          el.classList.remove(checkbox.value);
        }

        getCheckboxValues();
        setMapMarkers();
      });
    });

    window.onresize = debounce(() => {
      handleResize();
    }, 200);
  };

  const init = () => {
    setMapTiles();
    setMapMarkers();
    switchToListView();
    addEvents();
  };

  init();
};

export default Openstreetmap;
